module.exports = __webpack_public_path__ + "static/media/scene5_sama3.deef60dd.wav";